import Invitation from "../Entities/Invitation";
import * as Yup from "yup";
import CrudApi from "@serie3/common/api/crudApi";
import InvitationConfig from "../Resources/Endpoints";

const createInvitationForm = (invitationList = null, setInvitationList = null, groupId = null) => {
  const validationSchema = Yup.object({
    user_mail: Yup.string().email("Invalid email").required("Required"),
  });

  const onSubmit = async (values) => {
    const caps = Array.isArray(values.caps)
      ? values.caps
      : [values.caps].filter(Boolean);

    // If only date given, add a time (e.g. 00:00)
    let invitedTill = values.invited_till;
    if (/^\d{4}-\d{2}-\d{2}$/.test(invitedTill)) {
      invitedTill = invitedTill + "T00:00";
    }

    const payload = JSON.stringify(
      {
        user_mail: values.user_mail.trim(),
        caps,
        invited_till: invitedTill,
      },
      null,
      2
    );

    const response = await CrudApi.createNew(
      InvitationConfig.endpoints.invite + groupId,
      payload
    );
    if (response.status === 200) {
      setInvitationList && setInvitationList((prev) => [...invitationList, response.data]);
    }
  };

  return {
    initialValues: Invitation,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      onSubmit(values);
    },
  };
};

/** No Edit Data, remove invitation and send new one */

export default { createInvitationForm };
